export const USER_REGISTER_REQUEST = "user/register/request";
export const USER_REGISTER_SUCCESS = "user/register/success";
export const USER_REGISTER_FAILED = "user/register/failed";

export const USER_LOGIN_REQUEST = "user/login/request";
export const USER_LOGIN_SUCCESS = "user/login/success";
export const USER_LOGIN_FAILED = "user/login/failed";

export const USER_LOGOUT = "user/logout";
